module.exports = __webpack_public_path__ + "media/images/payment/gopay-76eeb4bf04dc06b136135edd9cfbadc3.png";